import { Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { selectDialogState } from 'app/dialog/features/dialog.selectors';
import { DialogService } from 'app/dialog/services/dialog.service';
import { UntypedFormControl, Validators, FormGroupDirective, NgForm, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';

import { ErrorStateMatcher } from '@angular/material/core';
import { selectVirtualEventData } from 'app/virtual-event/features/data/data.selectors';
import { StreamInfoStructure } from '../../../../event/models/stream-model';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-update-virtual-event',
  templateUrl: './update-virtual-event.component.html',
  styleUrls: ['./update-virtual-event.component.scss']
})
export class UpdateVirtualEventComponent implements OnInit, OnDestroy {
  destroyRef = inject(DestroyRef)
  public dialog$: Observable<any> = this.store.pipe(select(selectDialogState));
  public event$: Observable<any> = this.store.pipe(select(selectVirtualEventData));

  public streamProviderList: any[] = [
    {id: 0, label: "Other"},
    {id: 1, label: "YouTube"},
    {id: 2, label: "Facebook"},
    {id: 3, label: "Twitch"},
    {id: 4, label: "Paybee"}
  ];

  public form: UntypedFormGroup = null;

  matcher = new MyErrorStateMatcher();
  public selectedProvider: number;
  public event: any;
  public paybeeStreamInfo: StreamInfoStructure;

  constructor(
    private store: Store,
    private dialogService: DialogService,
    private formBuilder: UntypedFormBuilder,
  ) {}

  ngOnInit(): void {
    this.event$.pipe(
      takeUntilDestroyed(this.destroyRef)
    )
      .subscribe(data => {
        this.selectedProvider = data.streamProvider;
        this.paybeeStreamInfo = data.payBeeStreamingInfo;

        this.form = this.formBuilder.group({
          'streamProvider': new UntypedFormControl(data.streamProvider, [
            Validators.required,
          ]),
          'streamUrl': new UntypedFormControl(data.streamUrl, [
            Validators.required,
          ]),
          'goal': new UntypedFormControl(data.goal, [
            Validators.required,
            Validators.min(0)
          ])
        });

        this.form.get('streamProvider').setValue(parseInt(data.streamProvider));

        this.updateStreamValidator();

    });
  }

  ngOnDestroy(): void {
    this.dialogService.closeDialogSubject.next(null);
  }

  updateStreamValidator(event = null) {

    this.selectedProvider = event
    if (this.form.get('streamProvider').value !== 4) {
      this.form.get('streamUrl').addValidators(Validators.required);
      this.form.controls['streamUrl'].updateValueAndValidity();
    } else {
      this.form.get('streamUrl').clearValidators();
      this.form.controls['streamUrl'].updateValueAndValidity();
    }
  }

  close(dialog, value) {
    this.dialogService.closeDialogSubject.next(value);

    const {initialState: {action, callback}} = dialog;
    const {form} = this;
    const streamUrl = form.get('streamUrl');
    if (value) {
      if (action) {
        this.store.dispatch(action);
      }
      callback({
        streamProvider: this.selectedProvider,
        streamUrl: streamUrl.value
      });
    }
  }
}
